
export default function (Component) {
  Component.options.__source = "src/components/GlobalWatermark/index.vue"
}
